import Media from './media';

export default class ARQuickLook {
  linkText: string;
  arModel?: Media;
  quickLookIcon?: Media;
  notAvailableText?: string;
  placeholderImage?: Media;
  analyticsAttributes?: any;
  hideMobileNotSupported?: boolean;

  constructor(props: any) {
    this.linkText = props.linkText;
    this.arModel = props.arModel ? new Media(props.arModel) : undefined;
    this.quickLookIcon = props.quickLookIcon
      ? new Media(props.quickLookIcon)
      : undefined;
    this.notAvailableText = props.notAvailableText;
    this.analyticsAttributes = props.analyticsAttributes;
    this.placeholderImage = props.placeholderImage
      ? new Media(props.placeholderImage)
      : undefined;
    this.hideMobileNotSupported = props.hideMobileNotSupported;
  }
}
